import {RemitoTypeMapping, RemitoTypes} from '../constants/RemitoTypes';

export class ViewRemitos {

  public get remitoType(): RemitoTypes | undefined {
    return RemitoTypeMapping.MAPPING.get(this.origen);
  }

  public get nroShipperString(): string {
    return this.nroShipper?.toString() ?? '';
  }

  nroRemito: number;
  nroShipper: number | null;
  origen: string;
  nameSolicitante: string;
  almacen: string;
  codAlmacen: string;
  descAlmacen: string;
  dock: string | null;
  fecGen: Date | null = new Date();
  fecModif: Date | null;
  fecARetornar: Date | null= new Date();
  fecProrrogas: Date | null= new Date();
  fecRetorno: Date | null= new Date();
  estadoRemito: string;
  ptoEmision: string;
  cancelarFecha: Date | null;
  cancelarObservacion: string | null;
  isChecked: boolean;

  /**
   * This maps the data obj received from http client, which
   * contains nroRemito as a number, to a ViewRemitos.ts obj with nroRemito
   * as a string for compatibility with our column filters.
   * @param data The data received from HttpClient.
   */
  static transformViewRemitosData(data: any): ViewRemitos {
    let viewRemitosData = new ViewRemitos();
    viewRemitosData.nroRemito = data.nroRemito.toString().padStart(8, '0');
    viewRemitosData.nameSolicitante = data.nameSolicitante;
    viewRemitosData.codAlmacen = data.codAlmacen;
    viewRemitosData.descAlmacen = data.descAlmacen;
    viewRemitosData.dock = data.dock;
    viewRemitosData.fecGen = data.fecGen != null ? new Date(data.fecGen) : null;
    viewRemitosData.fecModif = data.fecModif != null ? new Date(data.fecModif) : null;

    viewRemitosData.fecARetornar = data.fecARetornar != null ? new Date(data.fecARetornar) : null;
    viewRemitosData.fecProrrogas = data.fecProrrogas != null ? new Date(data.fecProrrogas) : null;
    viewRemitosData.fecRetorno = data.fecRetorno != null ? new Date(data.fecRetorno) : null;

    viewRemitosData.estadoRemito = data.estadoRemito;
    viewRemitosData.ptoEmision = data.ptoEmision;
    viewRemitosData.cancelarFecha = data.cancelarFecha;
    viewRemitosData.cancelarObservacion = data.cancelarObservacion;
    viewRemitosData.isChecked = data.isChecked
    viewRemitosData.origen = data.origen;
    viewRemitosData.nroShipper = data.nroShipper;

    return viewRemitosData;
  }
}

export interface Status {
  value: string;
  valueType: string;
}
